module.exports = __webpack_public_path__ + "static/rose-d881ac5d4b7d336cb1d9f8f67e303c33.jpg";